// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu__container-f57845 {
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0px;
}

.Menu__popover-b38c2f {
  background: var(--base-0) !important;
  flex-direction: row;
  background: none;
  box-shadow: none;
  border: none;
}

.Menu__popover-opened-bfbf3c {
  background-color: var(--base-40);
}

.Menu__icon-cfcf85 {
  width: 24px;
  height: 24px;
  fill: var(--base-120);
}

.Menu__item-bb4637 {
  width: 36px;
  height: 36px;
  background-color: var(--base-20);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  margin-inline-start: 14px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Menu/styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  padding: 0px;\n}\n\n.popover {\n  background: var(--base-0) !important;\n  flex-direction: row;\n  background: none;\n  box-shadow: none;\n  border: none;\n}\n\n.popover-opened {\n  background-color: var(--base-40);\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  fill: var(--base-120);\n}\n\n.item {\n  width: 36px;\n  height: 36px;\n  background-color: var(--base-20);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  margin-inline-start: 14px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Menu__container-f57845`,
	"popover": `Menu__popover-b38c2f`,
	"popover-opened": `Menu__popover-opened-bfbf3c`,
	"popoverOpened": `Menu__popover-opened-bfbf3c`,
	"icon": `Menu__icon-cfcf85`,
	"item": `Menu__item-bb4637`
};
module.exports = ___CSS_LOADER_EXPORT___;
